/**
 * LoadingSpinner Component
 * Centralized loading spinner component
 */

import { ThreeDots } from "react-loader-spinner";

/**
 * LoadingSpinner - Reusable loading spinner component
 * @param {Object} props
 * @param {string} props.color - Spinner color (default: "white")
 * @param {number} props.height - Spinner height (default: 38)
 * @param {number} props.width - Spinner width (default: 40)
 * @param {number} props.radius - Spinner radius (default: 9)
 * @param {string} props.ariaLabel - Accessibility label (default: "three-dots-loading")
 * @param {string} props.className - Additional CSS classes
 */
const LoadingSpinner = ({
  color = "white",
  height = 38,
  width = 40,
  radius = 9,
  ariaLabel = "three-dots-loading",
  className = "",
}) => {
  return (
    <ThreeDots
      height={height}
      width={width}
      radius={radius}
      color={color}
      ariaLabel={ariaLabel}
      wrapperClass={className}
      visible={true}
    />
  );
};

export default LoadingSpinner;
